import SelectEdit from './SelectEdit';

export default SelectEdit;
